export enum MediaEndpoints {
  Mobile = 768,
  Tablet = 1024,
}
